import React from "react"
import CurrencyInput from "../CurrencyInput/CurrencyInput"

class IncidentalDepositDetails extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="panel panel-default">
        <div className="panel-body container">
          <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, marginTop: 5, marginBottom: 10 }}>{I18n.t('incidental_deposit')} - {I18n.t(this.props.incidental_deposit.deposit_type)}
          </h3>
          <div className={"folios "}>
            <div className="folio-amount" >
              <div className="row" style={{ margin: '0px' }}>

                <div className="col-md">
                  <label>{I18n.t('name')}</label>
                  <br />
                  <div>{this.props.incidental_deposit.name}</div>
                </div>

                <div className="col-md">
                  <label>{I18n.t('deposit')}</label>
                  <br />
                  <div>{this.renderDepositType()}</div>
                </div>

                <div className="col-md">
                  <div className="amount">
                    <label>{I18n.t('amount')}</label>
                    <br />
                    <CurrencyInput min={100} name="amount" value={this.props.amount} className={this.props.errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Amount')) ? "form-control has-errors" : "form-control"} onChange={this.props.onChangeIncidentalAmount} />
                    {this.props.errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Amount')) ? <div className="help-block"><ul><li><b>&#x2022;</b>{this.props.errors.header_errors.find(error => error.includes('Amount'))}</li></ul></div> : null}
                  </div>
                </div>

                <div className="col-md">
                  <label>{I18n.t('includes_balance')} </label>
                  <p>{this.props.incidental_deposit.include_reservation_balance ? I18n.t('yes') : I18n.t('no')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderDepositType(){
    if (this.props.incidental_deposit.incidental_amount) {
      return(
        this.props.formatCurrency(this.props.incidental_deposit.incidental_amount)
      );
    } else if (this.props.incidental_deposit.incidental_nights){
      return(
        `${this.props.incidental_deposit.incidental_nights} ${I18n.t('nights')}`
      );
    } else if (this.props.incidental_deposit.incidental_percentage){
      return(
        `${this.props.incidental_deposit.incidental_percentage * 100}% ${I18n.t('of_room_total')}`
      );
    };
  };
};

export default IncidentalDepositDetails
